<template>
  <section v-if="isVisible" id="resources" class="section server-section server-showcase" v-reveal>
    <div class="section-heading section-heading--center">
      <p class="section-kicker">{{ showcase.kicker }}</p>
      <h2>{{ showcase.title }}</h2>
      <p>{{ showcase.copy }}</p>
    </div>

    <div class="server-orbit-list">
      <article
        v-for="(server, index) in displayServers"
        :key="server.id || server.name"
        class="server-orbit-card"
        :class="`server-orbit-card--${server.tone}`"
        :style="{ '--delay': `${index * 80}ms` }"
      >
        <span class="server-orbit-card__avatar">
          <img v-if="server.icon" :src="server.icon" :alt="server.name" />
          <span v-else>{{ server.initials }}</span>
        </span>
        <h3>{{ server.name }}</h3>
        <p>{{ server.members }} {{ showcase.memberLabel }}</p>
      </article>
    </div>

  </section>
</template>

<script>
import { fetchServerStats } from '../services/serverStatsService'

export default {
  name: 'ServerSection',
  props: {
    servers: {
      type: Array,
      required: true
    },
    showcase: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      apiServers: [],
      hasLoadedServerStats: false
    }
  },
  computed: {
    isVisible() {
      return this.hasLoadedServerStats
    },
    displayServers() {
      return this.apiServers
    }
  },
  mounted() {
    this.loadServerStats()
  },
  methods: {
    async loadServerStats() {
      try {
        const servers = await fetchServerStats()

        this.apiServers = servers
          .map((server, index) => ({
            name: server.name,
            icon: server.icon,
            members: this.formatMemberCount(server.memberCount),
            initials: this.getInitials(server.name),
            tone: this.servers[index % this.servers.length]?.tone || 'cyan',
            memberCount: Number(server.memberCount) || 0
          }))
          .sort((first, second) => second.memberCount - first.memberCount)
          .slice(0, 5)
        this.hasLoadedServerStats = true
      } catch (error) {
        this.apiServers = []
        this.hasLoadedServerStats = false
      }
    },
    formatMemberCount(memberCount) {
      return new Intl.NumberFormat(navigator.language || 'de-DE').format(Number(memberCount) || 0)
    },
    getInitials(name) {
      return (name || 'GG')
        .split(/\s+/)
        .filter(Boolean)
        .slice(0, 2)
        .map((part) => part.charAt(0).toUpperCase())
        .join('')
    }
  }
}
</script>
